let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("85Y84")).then(() => parcelRequire('lKrWz'));